package com.evoapps.evoshift.ui.util

import androidx.compose.runtime.Composable
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.person_name_unavailable
import org.jetbrains.compose.resources.stringResource

/**
 * SH-235: how a person on a shift is shown: their name (ResolvePersonNamesUseCase), else the
 * label "Employee (name unavailable)", never a blank or their user id.
 */
@Composable
fun personName(name: String?): String =
    name?.takeIf { it.isNotBlank() } ?: stringResource(Res.string.person_name_unavailable)

/**
 * SH-237: [personName] for an argument of a view model's [UiText.Resource]: the name itself, else
 * the "name unavailable" label as a [UiText] the screen resolves in its language.
 */
fun personNameArg(name: String?): Any =
    name?.takeIf { it.isNotBlank() } ?: UiText.Resource(Res.string.person_name_unavailable)
